module.exports = __webpack_public_path__ + "img/icon-ban.91725d20.svg";